import React from 'react';
import PropTypes from 'prop-types';

import * as Cookie from 'js-cookie';

import {connect} from 'react-redux';

import {fetchAffiliate} from '../../ducks/affiliate';

import ErrorPage from '../errorPage/ErrorPage';
import Loader from '../../components/loader/Loader';

@connect(({affiliate}, {params}) => ({affiliate: affiliate[params.splat]}))
export default class AffiliatePage extends React.PureComponent {
  static fetchData = ({dispatch, params}) => dispatch(fetchAffiliate(params.splat));

  componentDidMount() {
    const {affiliate} = this.props;

    if (affiliate === undefined) {
      AffiliatePage.fetchData(this.props);
    }

    if (affiliate) {
      Cookie.set('affiliate', affiliate.code, {expires: 365});
      window.location = affiliate.targetUrl;
    }
  }

  componentWillReceiveProps(nextProps) {
    const {affiliate} = nextProps;

    if (affiliate === undefined) {
      AffiliatePage.fetchData(nextProps);
    }

    if (affiliate) {
      Cookie.set('affiliate', affiliate.code, {expires: 365});
      window.location = affiliate.targetUrl;
    }
  }

  render() {
    const {affiliate} = this.props;

    if (affiliate === false) {
      return <ErrorPage/>;
    }

    return <Loader page/>;
  }
}



// WEBPACK FOOTER //
// ./containers/affiliatePage/AffiliatePage.js